import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import ContentLibraryForTreatment from './ContentLibraryForTreatment';
import { ToastContainer, toast } from "react-toastify";
// import ReactTable from "react-table"
import DataTable from 'react-data-table-component';
import ErrorBoundary from '../../ErrorBoundary';
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import cssu

class ContentLibraryTreatmentTabSettings extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            showViewVersionPopUp: false,
            sharedToPublic: false,
        }
        this.userDetails = JSON.parse(localStorage.getItem("user_details"));
    }

    componentDidMount() {
        (function () {
            var currentPath = window.location.href;

            var path = window.origin + "/my-jeeva/projectmgmt/treatment-content-library";
            var path1 = window.origin + "/my-jeeva/projectmgmt/treatment-content-library/";
            if (currentPath == path || currentPath == path1) {
                $("#treatment-content-library").addClass('active');
            } else {
                $("#" + localStorage.getItem("last-project-survey-tab")).addClass('active')
            }
            $("#treatment-content-library")
                .on("click", function () {
                    $("#treatment-content-library")
                        .removeClass('active');
                    localStorage.setItem("last-project-about-tab", $(this)[0].id);

                    $(this).addClass('active')

                })
        })();
    }


    goBackFromSubTab = () => {
        localStorage.setItem("parentFolderId", null);
        var userRole = JSON.parse(localStorage.getItem("user_details"))["userRole"];
        if (userRole == "PHYSICIAN") {
            this.props.history.push({
                pathname: "/projectmgmt",
                state: {
                    healthSystemId: this.props.location.state.healthSystemId,
                    hospitalId: this.props.location.state.hospitalId,
                    treatmentId: this.props.location.state.treatmentId,
                    treatmentName: this.props.location.state.treatmentName
                }
            });
        } else {
            this.props.history.push({
                pathname: "/projectmgmt/procedure",
                state: {
                    healthSystemId: this.props.location.state.healthSystemId,
                    hospitalId: this.props.location.state.hospitalId,
                    treatmentId: this.props.location.state.treatmentId,
                    treatmentName: this.props.location.state.treatmentName
                }
            });
        }

    }
    saveVersion(props) {
        var saveVersionController = this;
        $.ajax({
            url: '/my-jeeva-api/save-version',

            method: 'GET',
            data: {
                scopeGroup: this.props.location.state.treatmentId,
                scope: "TREATMENT",
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success == true) {
                    console.log("called saveVersion");
                    saveVersionController.notifyNewVersionSaved();
                    setTimeout(() => {
                        window.ContentLibraryController.state.folderId = "00000000-0000-0000-0000-000000000000";
                        window.ContentLibraryController.fetchContent();
                    }, 200)
                }
            }
        })
    }
    notifyNewVersionSaved() {
        toast.dismiss();
        toast(
            <b>
                <img
                    src="assets/images/done.svg"
                    style={{ paddingRight: "0px" }}
                    content=""
                />
                A new version of this content has been saved. You will be redirected to the Home folder of the new version now.
            </b>,
            {
                position: "top-center",
            }
        );
    }

    viewVersion() {
        var viewVersionController = this;
        $.ajax({
            url: '/my-jeeva-api/view-version',

            method: 'GET',
            data: {
                scopeGroup: this.props.location.state.treatmentId,
                scope: "TREATMENT"
            },
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token")
            },
            success: function (res) {
                if (res.success == true) {
                    var versionArray = res.result;
                    viewVersionController.state.data = versionArray;
                    console.log("The versionArray is : " + versionArray);
                    if (versionArray && versionArray.length > 0) {
                        console.log("The state of published in view version is : " + res.result[0].published);
                    } else {
                        console.log("No versions found");
                    }
                    viewVersionController.state.showViewVersionPopUp = true;
                    viewVersionController.setState(viewVersionController.state);
                }
            }
        })
    }
    notifySavingContent() {
        toast.dismiss();
        toast(<b><img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
            &nbsp;&nbsp;Please fill all the fields before saving</b>, {
            position: "top-center"
        });
    }

    openShareToPublicPopUp = (rowId) => {
        confirmAlert({
            title: "Confirm to Share",
            message: "Are you sure to share this content to public?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => this.ShareToPublic(rowId),
                },
                {
                    label: "No",
                },
            ],
        });
    };

    openUnShareToPublicPopUp = (rowId) => {
        confirmAlert({
            title: "Confirm to Unshare",
            message: "Are you sure to unshare this content to public?",
            buttons: [
                {
                    label: "Yes",
                    onClick: () => this.UnShareToPublic(rowId),
                },
                {
                    label: "No",
                },
            ],
        });
    };

    ShareToPublic = (rowId) => {
        var sharedController = this;
        $.ajax({
            url: "/my-jeeva-api/share-to-public",

            method: "GET",
            data: {
                scopeGroup: this.props.location.state.treatmentId,
                scope: "TREATMENT",
                id: rowId,
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success == true) {
                    //   console.log(
                    //     "The state of published :" + sharedController.state.published
                    //   );
                    //   sharedController.notifySuccess(sharedController.newVersionInfo);

                    sharedController.viewVersion();

                    //window.location.reload();
                }
            },
        });
    };
    UnShareToPublic = (rowId) => {
        var sharedController = this;
        $.ajax({
            url: "/my-jeeva-api/un-share-to-public",

            method: "GET",
            data: {
                scopeGroup: this.props.location.state.treatmentId,
                scope: "TREATMENT",
                id: rowId,
            },
            headers: {
                Authorization: "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success == true) {
                    //   console.log(
                    //     "The state of sharedContent :" + publishController.state.published
                    //   );
                    // sharedController.notifySuccess(sharedController.newVersionInfo);

                    sharedController.viewVersion();

                    //window.location.reload();
                }
            },
        });
    };

    handleShareToggle = (rowId, currentState) => {
        if (currentState) {
            this.openUnShareToPublicPopUp(rowId);
        } else {
            this.openShareToPublicPopUp(rowId);
        }
    };

    // notifySuccess ()  {
    //     toast.dismiss();
    //     toast(<b><img src="assets/images/done.svg"
    //         style={{ paddingRight: '0px' }} content="" />
    //         &nbsp;&nbsp;Saving Version! Content will be reloaded</b>, {
    //         position: "top-center",
    //         toastId: 'dismisstoast1'
    //     });
    // }
    onPageChange = (e) => {
        this.setState({ pageNum: e })
    }
    render() {
        const columns = [
            {
                name: <b style={{ fontSize: '16px' }}> Version Number</b>,
                selector: (row) => (
                    <div name="Version">
                        <div className="textarea"
                            style={{
                                background: 'white', height: "2.7em", resize: 'none',
                                paddingLeft: '2px', paddingTop: '6px', width: '100%',
                                border: 'none',
                                borderRadius: 'none'
                            }}
                            id={"Version" + row.id}
                            contentEditable={false}
                        >{row.version}
                        </div>
                    </div>)
            },
            {

                name: <b style={{ fontSize: '16px' }}>Version Name</b>,
                selector: (row) => (

                    <div name="versionName">
                        <div className="textarea"
                            style={{
                                background: 'white', height: "2.7em", resize: 'none', paddingLeft: '2px', paddingTop: '6px',
                                width: '100%',
                                border: 'none',
                                borderRadius: 'none'
                            }}
                            id={"versionName" + row.id}
                            contentEditable={false}
                        >{row.versionName}
                        </div>
                    </div>)
            }, {
                name: <b style={{ fontSize: '16px' }}> Published</b>,
                selector: (row) => (
                    <div name="published">
                        <label className="switch">
                            <input type="checkbox"
                                id={"published" + row.id}
                                defaultChecked={row.published}
                                disabled={true}
                            />
                            <span className="slider round"></span>
                        </label>
                    </div>)
            },
            // {
            //     name: <b style={{ fontSize: '16px' }}> Share Content</b>,
            //     selector: (row) => (
            //         <div name="sharedToPublic">
            //             <label className="switch">
            //                 <input type="checkbox"
            //                     id={"sharedToPublic" + row.id}
            //                     checked={this.state.sharedToPublic[row.id] !== undefined ? this.state.sharedToPublic[row.id] : row.sharedContent}
            //                     onChange={() => this.handleShareToggle(row.id, this.state.sharedToPublic[row.id] !== undefined ? this.state.sharedToPublic[row.id] : row.sharedContent)}
            //                 />
            //                 <span className="slider round"></span>
            //             </label>
            //         </div>)
            // }
        ];

        return (
            <ErrorBoundary>
                <div id="tabPage">
                    <div className="content" style={{ backgroundColor: "#F9F9FB" }}>

                        <link rel="shortcut icon" type="image/png" href="assets/images/bot.ico" />
                        {/* Font Awesome Icons */}
                        <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />
                        {/* IonIcons */}
                        <link rel="stylesheet" href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css" />
                        <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
                        {/* Theme style */}
                        <link rel="stylesheet" href="assets/css/adminlte.css" />
                        <link href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css" rel="stylesheet" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <link rel="stylesheet" href="assets/css/styles.css" />
                        <link rel="stylesheet" href="assets/css/custom-style.css" />
                        <link rel="stylesheet" href="assets/css/ReactToastify.css" />
                        <div className="content-header" >
                            <div className="container-fluid">
                                <div className="row">
                                    <div className='col-sm-4'>
                                        <img src="assets/images/arrow.svg"
                                            style={{ paddingRight: "30%", cursor: 'pointer' }}
                                            onClick={this.goBackFromSubTab}
                                        />
                                    </div>
                                    <div className="col-sm-4" style={{ marginTop: '-1vw' }}>
                                        <h1 className="m-0 page-title">Content Library of {this.props.location.state.treatmentName}</h1>
                                    </div>
                                    <div className='col-sm-4' Align="right">
                                        <div style={{ display: 'none' }}>
                                            <button className="btn action-button"
                                                style={{ marginRight: '-2px' }}
                                                onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy") ? null :
                                                    () => this.saveVersion()}
                                                disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                                                    JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")}
                                            >Save Version</button>
                                        </div>
                                        <button className="btn action-button"
                                            style={{ marginRight: '-2px' }}
                                            onClick={this.userDetails["userRole"] === "PHYSICIAN" &&
                                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy") ? null :
                                                () => this.viewVersion()}
                                            disabled={this.userDetails["userRole"] === "PHYSICIAN" &&
                                                JSON.parse(localStorage.getItem('user_details')).emailId !== localStorage.getItem("createdBy")}
                                        >View Versions</button>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div className="modal" style={{ display: this.state.showViewVersionPopUp ? 'block' : 'none' }}>
                            <div className="modal-dialog" id="center-aligned-account-modal">
                                <div className="modal-content" style={{ height: "665px", width: "900px" }}>
                                    <div className="modal-header noBorder">
                                        <div className="row" style={{ marginTop: '-30px' }}>
                                            <div className="col-sm-12" align="center">
                                                <h1 className="m-0 page-title">View Versions</h1>
                                            </div>
                                        </div>
                                        <button type="button" className="close" data-dismiss="modal" id="close_id" onClick={() => { this.setState({ showViewVersionPopUp: false }) }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24">
                                                <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                                <path d="M0 0h24v24H0z" fill="none" />
                                            </svg>
                                        </button>
                                    </div>

                                    <div className="modal-body" style={{ marginTop: "1vh" }}>
                                        <form>
                                            <DataTable id='reactTable'
                                                columns={columns}
                                                data={this.state.data}
                                                fixedHeaderScrollHeight="170px"
                                                pagination={5}
                                                onPageChange={() => this.onPageChange()}
                                                paginationDefaultPage={this.state.pageNum}
                                            // paginationComponentOptions={{
                                            //     rowsPerPageText: 'Records per page:',
                                            //     rangeSeparatorText: 'out of',
                                            // }}

                                            // pageSize={this.state.data.length <= 5 ? 5 : this.state.data.length}
                                            // showPagination={false}
                                            // style={{ height: '500px', marginTop:'3vw' }}
                                            />

                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <ToastContainer className="Toast-at-center" />

                        <div className="container-fluid" >

                            <div className="border-bottom"></div>
                            <div className="tab-class">

                                <ul className="nav nav-tabs border-bottom navCluster">

                                    <div className="nav-item" data-toggle="tab">
                                        {/* to="/projectmgmt/treatment-content-library" style={{ textDecoration: 'none' }} */}
                                        <li className="nav-link" id="treatment-content-library" style={{ marginLeft: '1vw' }}>
                                            Library
                                        </li>
                                    </div>


                                </ul>
                            </div>
                        </div>
                    </div>
                    <Switch>
                        <Route path="/projectmgmt/treatment-content-library" component={ContentLibraryForTreatment}></Route>
                    </Switch>
                </div>
            </ErrorBoundary>
        );
    }
}
export default ContentLibraryTreatmentTabSettings;




// WEBPACK FOOTER //
// src/my-jeeva/projectmgmt/ContentLibraryTreatmentTabSettings.js